"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var defaultOptions = {
    maxResultsForAddCities: 5,
    minStringLengthForSearch: 1
};
var AddressAutocomplete = /** @class */ (function () {
    function AddressAutocomplete(webServer, options) {
        this._currentAddress = null;
        this._currentAddressString = '';
        this._lat = null;
        this._lon = null;
        this._regionPlusIds = undefined;
        this._countryName = undefined;
        this._webServer = webServer;
        this._options = Object.assign({}, defaultOptions, options);
    }
    AddressAutocomplete.prototype.SetCenter = function (lat, lon) {
        this._lat = lat;
        this._lon = lon;
    };
    AddressAutocomplete.prototype.RegionPlusIds = function (regionPlusIds) {
        this._regionPlusIds = regionPlusIds;
    };
    AddressAutocomplete.prototype.CountryName = function (countryName) {
        this._countryName = countryName;
    };
    AddressAutocomplete.prototype.GetAddresses = function (parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response, responseEmpty;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(parameters.searchText.length >= this._options.minStringLengthForSearch
                            || parameters.searchType === types_1.SearchType.house)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._webServer.getAddress(parameters)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        responseEmpty = new Promise(function (resolve) {
                            resolve({ HttpStatus: 200, HttpStatusText: '200', Success: true });
                        });
                        return [2 /*return*/, responseEmpty];
                }
            });
        });
    };
    AddressAutocomplete.prototype.SearchTextReplace = function (newTextValue) {
        if (this._currentAddress) {
            return (newTextValue.replace(((this._currentAddress.t === "s" || this._currentAddress.t === "c")
                ? this._currentAddress.v.replace(/ *\([^)]*\) */g, "")
                : (this._currentAddress.s && this._currentAddress.s.replace(/ *\([^)]*\) */g, ""))) + ', ', ''));
        }
        else {
            return newTextValue;
        }
    };
    AddressAutocomplete.prototype.ChangeInputValue = function (newTextValue, lang) {
        return __awaiter(this, void 0, void 0, function () {
            var searchText, _lang, parameters;
            return __generator(this, function (_a) {
                if (this._currentAddress !== null
                    && !newTextValue.startsWith(this._currentAddress.v.replace(/ *\([^)]*\) */g, "") + ',')
                    && !newTextValue.startsWith(this._currentAddress.s && this._currentAddress.s.replace(/ *\([^)]*\) */g, "") + ',')) {
                    this._currentAddress = null;
                }
                searchText = this.SearchTextReplace(newTextValue);
                _lang = lang ? lang : undefined;
                if (this._currentAddress) {
                    if (this._currentAddress.t === "c") {
                        parameters = {
                            searchText: searchText,
                            searchType: null,
                            cityId: this._currentAddress.cid,
                            lang: _lang
                        };
                    }
                    else {
                        parameters = {
                            searchText: searchText,
                            searchType: types_1.SearchType.house,
                            countryName: this._currentAddress.co,
                            city: this._currentAddress.c,
                            street: this._currentAddress.t === "s" ? this._currentAddress.v : this._currentAddress.s,
                            regionPlusIds: this._regionPlusIds,
                            cityId: this._currentAddress.cid,
                            lang: _lang
                        };
                    }
                }
                else {
                    parameters = {
                        searchText: searchText,
                        lat: this._lat,
                        lon: this._lon,
                        regionPlusIds: this._regionPlusIds,
                        countryName: this._countryName,
                        searchType: null,
                        lang: _lang
                    };
                }
                return [2 /*return*/, this.GetAddresses(parameters)];
            });
        });
    };
    AddressAutocomplete.prototype.SetSelectedAddress = function (address) {
        this._currentAddress = address;
        if (address.t === "h") {
            this._currentAddressString = address.s + ', ' + address.v;
            return;
        }
        if (address.t === "o") {
            this._currentAddressString = (address.c ? address.c + ', ' : "") + address.v;
            return;
        }
        this._currentAddressString = address.v + ', ';
    };
    AddressAutocomplete.prototype.GetSelectedAddress = function () {
        return this._currentAddress;
    };
    AddressAutocomplete.prototype.GetCurrentAddressString = function () {
        return this._currentAddressString.replace(/ *\([^)]*\) */g, "");
    };
    return AddressAutocomplete;
}());
exports.AddressAutocomplete = AddressAutocomplete;
//# sourceMappingURL=AddressAutocomplete.js.map